export const appGroupIdBrazeMcpTools = "/:app_group_id/braze_mcp/tools";
